import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { SvgIconTypeMap } from "@mui/material";

const SerialNumberLookupIcon: OverridableComponent<
  SvgIconTypeMap<{}, "svg">
> & { muiName: string } = (props: SvgIconProps) => {
  const { width = 72, height = 72, color = "#9E233A", ...otherProps } = props;

  return (
    <SvgIcon
      {...otherProps}
      viewBox="0 0 72 72"
      sx={{ width, height }}
    >
      <g id="lookup">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M40.0469 3C40.5772 3.00008 41.0859 3.21094 41.4609 3.58594L59.4141 21.5391C59.7891 21.9141 59.9999 22.4228 60 22.9531V42.6162C58.2069 42.0303 56.3057 41.6831 54.333 41.6162V25.3125H37.6875V8.66699H15.667C15.1147 8.66699 14.667 9.11471 14.667 9.66699V60.083C14.667 60.6353 15.1147 61.083 15.667 61.083H38.5488C40.9567 63.6869 44.0277 65.6656 47.4941 66.75H15.375C13.6842 66.75 12.0627 66.0784 10.8672 64.8828C9.67164 63.6873 9 62.0658 9 60.375V9.375C9 7.68424 9.67164 6.06273 10.8672 4.86719C12.0627 3.67164 13.6842 3 15.375 3H40.0469ZM39.8545 46.917C38.0762 48.5274 36.5779 50.4422 35.4473 52.583H21.75V46.917H39.8545ZM47.25 35.583V41.25H21.75V35.583H47.25Z"
          fill={color}
        />
        <path
          d="M55.25 44.625C48.4318 44.625 42.6091 48.8659 40.25 54.8523C42.6091 60.8386 48.4318 65.0795 55.25 65.0795C62.0682 65.0795 67.8909 60.8386 70.25 54.8523C67.8909 48.8659 62.0682 44.625 55.25 44.625ZM55.25 61.6705C51.4864 61.6705 48.4318 58.6159 48.4318 54.8523C48.4318 51.0886 51.4864 48.0341 55.25 48.0341C59.0136 48.0341 62.0682 51.0886 62.0682 54.8523C62.0682 58.6159 59.0136 61.6705 55.25 61.6705ZM55.25 50.7614C52.9864 50.7614 51.1591 52.5886 51.1591 54.8523C51.1591 57.1159 52.9864 58.9432 55.25 58.9432C57.5136 58.9432 59.3409 57.1159 59.3409 54.8523C59.3409 52.5886 57.5136 50.7614 55.25 50.7614Z"
          fill={color}
        />
      </g>
    </SvgIcon>
  );
};

SerialNumberLookupIcon.muiName = "SvgIcon";

export default SerialNumberLookupIcon;
